import React from "react"
import { FormControlLabel, Radio, Typography, RadioGroup } from "@mui/material"
import theme from "src/v2/theme/theme"
import PropTypes from "prop-types"
import ButtonWithIcon from "src/v2/components/Button/Button"
import { ReactComponent as TrashIcon } from "src/v2/assets/icons/trash-icon.svg"
import { ReactComponent as DownloadIcon } from "src/v2/assets/icons/download-cloud-icon.svg"

export const RadioButtonTable = ({
    defaultRadioValue,
    radioButtonItems,
    onChange,
}) => (
    <RadioGroup
        row
        aria-labelledby="access-level-radio-buttons-group-label"
        defaultValue={defaultRadioValue}
        name="radio-buttons-group"
    >
        {radioButtonItems.map((option) => (
            <FormControlLabel
                key={option.value}
                value={option.value}
                onChange={onChange}
                control={
                    <Radio
                        sx={{
                            "&.Mui-checked": {
                                color: theme.palette.primary.main2,
                                "& .MuiSvgIcon-root:last-of-type": {
                                    transform: "scale(0.5)",
                                },
                            },
                            "& .MuiSvgIcon-root": {
                                width: "20px",
                                height: "20px",
                            },
                            "& .MuiSvgIcon-root:first-of-type": {
                                color: theme.palette.white.main,
                            },
                        }}
                    />
                }
                label={
                    <Typography variant="body2" color="common.white">
                        {option.label}
                    </Typography>
                }
                sx={{
                    height: "24px",
                }}
            />
        ))}
    </RadioGroup>
)

RadioButtonTable.propTypes = {
    defaultRadioValue: PropTypes.string.isRequired,
    radioButtonItems: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    onChange: PropTypes.func.isRequired,
}

export const DeleteButton = (props) => {
    return (
        <ButtonWithIcon icon={<TrashIcon />} {...props}>
            EXCLUIR
        </ButtonWithIcon>
    )
}

export const FileNameColumn = (props) => {
    return (
        <div
            style={{ display: "flex", gap: "8px", alignItems: "center" }}
            {...props}
        >
            <div>
                <DownloadIcon style={{ color: "#E3A107" }} />
            </div>
            {props.children}
        </div>
    )
}

FileNameColumn.propTypes = {
    children: PropTypes.any,
}
